import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import EmailConfigService from '@/services/SettingsServices/EmailConfigService';
import { extractError } from '@/helpers/extractApiError';

const model = {
    data: null,
    submitting: false,
    errors: null,
    successOnCreate: '',
    loading: false,
};

export const getEmailConfig = createAsyncThunk(
    'email/getEmailConfig',
    async (_, { rejectWithValue }) => {
        try {
            const response = await EmailConfigService.getEmailConfig();
            return response.data;
        } catch (error) {
            return rejectWithValue(extractError(error));
        }
    },
);

export const addEmailConfig = createAsyncThunk(
    'email/addEmailConfig',
    async (data, { rejectWithValue }) => {
        try {
            const response = await EmailConfigService.addEmailConfig(data);
            return response.data;
        } catch (error) {
            return rejectWithValue(extractError(error));
        }
    },
);

const emailSlice = createSlice({
    name: 'email',
    initialState: model,
    reducers: {
        resetEmailStateOnError: (state) => {
            state.errors = null;
        },
        resetEmailStateOnSuccess: (state) => {
            state.successOnCreate = '';
        },
    },
    extraReducers: (builder) => {
        // get email config
        builder.addCase(getEmailConfig.pending, (state) => {
            state.loading = true;
        }).addCase(getEmailConfig.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        }).addCase(getEmailConfig.rejected, (state) => {
            state.loading = false;
        });

        // add email config
        builder.addCase(addEmailConfig.pending, (state) => {
            state.submitting = true;
        }).addCase(addEmailConfig.fulfilled, (state) => {
            state.submitting = false;
            state.successOnCreate = 'Email Configuration added successfully!';
        }).addCase(addEmailConfig.rejected, (state, action) => {
            state.submitting = false;
            state.errors = action.payload;
        });
    },
});

export const {
    resetEmailStateOnError,
    resetEmailStateOnSuccess,
} = emailSlice.actions;

export default emailSlice.reducer;
